<template>
  <div class="p-6 action-container">
    <!-- Action Type Selection -->
    <div class="d-flex justify-content-end align-items-center gap-2 mb-2">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Tipo de Acción
      </label>
      <select
        class="w-full px-3 py-2 border border-gray-300 rounded-lg"
        v-model="action.type"
      >
        <option value="">Seleccione una acción</option>
        <option
          v-for="(key, value) in ACTION_TYPES_NAMES"
          :value="value"
          :key="value"
        >
          {{ key }}
        </option>
      </select>
      <b-button
        size="sm"
        variant="outline-danger"
        class="shadow"
        title="Eliminar accion"
        v-b-tooltip.hover="'Eliminar grupo de condiciones'"
        @click="$emit('removeAction')"
      >
        <feather-icon icon="TrashIcon"/>
      </b-button>
    </div>

    <!-- Dynamic Form Section -->
    <component
      :is="actionFormComponent" v-if="actionFormComponent"
      :state="action"
    />
  </div>
</template>
<script>

import { BButton } from 'bootstrap-vue';

import { ACTION_REQUIRED_CONFIG, ACTION_TYPES_NAMES } from '@/febos/global/rules/util/actions';

export default {
  name: 'ActionsForm',
  props: {
    actiondata: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      action: {
        type: null,
        config: {}
      }
    };
  },
  mounted() {
    this.action = this.actiondata;
  },
  computed: {
    ACTION_TYPES_NAMES() {
      return ACTION_TYPES_NAMES;
    },
    ACTION_REQUIRED_CONFIG() {
      return ACTION_REQUIRED_CONFIG;
    },
    actionFormComponent() {
      try {
        return ACTION_REQUIRED_CONFIG[this.action?.type].form || null;
      } catch (e) {
        return null;
      }
    }
  },
  components: { BButton }
};
</script>
<style scoped>
.action-container {
  border: 0.5px dashed rgb(var(--vs-primary));
}
</style>
